export const TYPE_JSON = 'JSON';
export const TYPE_VISUAL = 'visual';

export const TYPE_JSON_LABEL = 'JSON';
export const TYPE_VISUAL_LABEL = 'Visual';

export const TYPE_JSON_COLOR = 'actionable';
export const TYPE_VISUAL_COLOR = 'brandAccent';

const botspecTypes = [
  {
    label: TYPE_JSON_LABEL,
    value: TYPE_JSON,
    color: TYPE_JSON_COLOR,
  },
  {
    label: TYPE_VISUAL_LABEL,
    value: TYPE_VISUAL,
    color: TYPE_VISUAL_COLOR,
  },
];

export default botspecTypes;
